import { SHIPPED_SHIELD_SKU } from '@/data/constants/SHIPPED_SHIELD_SKU'

export const toShippingProtectionSKU = ({
  offerId,
  items,
}: {
  offerId: string,
  items: readonly { sku: string, quantity: number, price: number }[],
}) => `${SHIPPED_SHIELD_SKU};${offerId};${items.map(({
  sku,
  quantity,
  price,
}) => `${sku}_${quantity}_${price}`).join(',')}`
